export default __webpack_public_path__ + "static/media/cubmu.066d7853.svg";